import * as he from 'he';

export const convertMarkdownToPlainText = (markdown: string): string => {
  // Remove escape backslashes before special characters (e.g., \[ \] \* \_ \#)
  markdown = markdown.replace(/\\([[\]*_#`~\\>!|-])/g, '$1');

  // Replace headers (atx-style)
  markdown = markdown.replace(/^#{1,6}\s*(.+)$/gm, '$1');

  // Replace bold (**text** or __text__)
  markdown = markdown.replace(/\*\*(.+?)\*\*/g, '$1');
  markdown = markdown.replace(/__(.+?)__/g, '$1');

  // Replace italics (*text* or _text_)
  markdown = markdown.replace(/\*(.+?)\*/g, '$1');
  markdown = markdown.replace(/_(.+?)_/g, '$1');

  // Replace strikethroughs (~~text~~)
  markdown = markdown.replace(/~~(.+?)~~/g, '$1');

  // Replace inline code (`code`)
  markdown = markdown.replace(/`(.+?)`/g, '$1');

  // Remove code blocks (fenced code blocks)
  markdown = markdown.replace(/```[\s\S]*?```/g, '');

  // Remove images (![alt text](image_url))
  markdown = markdown.replace(/!\[.*?\]\(.*?\)/g, '');

  // Replace links [text](url) with 'text (url)'
  markdown = markdown.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '$1 ($2)');

  // Replace unordered list items (-, *, +) with '- ' while preserving indentation
  // Matches: start of line, optional newlines (not captured), then captures spaces/tabs before list marker
  markdown = markdown.replace(/^(?:\n)*([ \t]*)[*\-+]\s+/gm, '$1- ');

  // Replace blockquotes (> ), including nested (> > )
  markdown = markdown.replace(/^(\s*>\s*)+/gm, '');

  // Remove horizontal rules (---, ***, ___)
  markdown = markdown.replace(/^\s*(-{3,}|\*{3,}|_{3,})\s*$/gm, '');

  // Remove HTML tags
  markdown = markdown.replace(/<\/?[^>]+(>|$)/g, '');

  // Decode HTML entities LAST, after tag-stripping. The v3 editor serializes
  // characters a clinician literally typed — `<`, `>`, `&`, quotes — as entities
  // (`&lt;` `&gt;` `&amp;` …). Without this, the EHR push (Siloam/MovementX)
  // delivers garbled text like "BP &gt; 140". Decoding after the tag-strip means
  // a literally-typed `<foo>` (stored as `&lt;foo&gt;`) survives as text rather
  // than being eaten as a tag. ENG-4453.
  markdown = he.decode(markdown);

  // Replace multiple newlines with a single newline
  markdown = markdown.replace(/\n{2,}/g, '\n\n');

  // Trim leading and trailing whitespace
  return markdown.trim();
};

export const convertMarkdownToPlainTextRecursively = (
  data: unknown,
): unknown => {
  if (typeof data === 'string') {
    return convertMarkdownToPlainText(data);
  }

  if (data && typeof data === 'object' && !Array.isArray(data)) {
    const converted: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(data)) {
      converted[key] = convertMarkdownToPlainTextRecursively(value);
    }
    return converted;
  }

  return data;
};
